import { Injectable } from '@angular/core';
import { SessionStorageService } from './session-storage.service';
import { HttpClient, HttpRequest, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { last, map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { throwError } from '../../node_modules/rxjs';

@Injectable()
export class AjaxService {
  /**
   * Session service
   */
  private $session: SessionStorageService = new SessionStorageService();

  /**
   * API 도메인
   */
  private api: string;

  // private DEFAULT_URL: string = 'http://localhost:3000/';
  // private DEFAULT_URL : string = 'http://crm-dev.bbwithu.com/';
  private DEFAULT_URL : string = 'http://crm.bbwithu.com/';

  constructor(
    private $http: HttpClient,
    private $router: Router) {}

  /**
   * 도메인 설정
   * @param {string} api 도메인 주소
   */
  setAPIDomain(api: string) {
    this.api = api + '/';
  }

  /**
   * 도메인 반환
   * @return {string}
   */
  getAPIDomain() {
    return this.api || this.DEFAULT_URL;
  }

  httpRequest(
    method: string,
    url: string,
    body?: object,
    header?: HttpHeaders): Observable<any> {

    const _HEADER: HttpHeaders = new HttpHeaders({
      'Content-Type':  'application/json',
      Authorization: 'Bearer ' + this.$session.getAuthorizationToken(),
    });

    const req = new HttpRequest(
        method,
        url,
        body ? body : {}, {
          headers: header ? header : _HEADER,
        },
    );
    return this.$http.request(req).pipe(
        catchError((err: any): any => {
          if (err.status === 401) {
            this.$router.navigate(['']);
          }
          return throwError(err);
        }),
        last(),
        map((m: HttpResponse<any>) => {
          return m.body;
        }),
    );
  }
}
